import { render, staticRenderFns } from "./ValuesTable.vue?vue&type=template&id=45b69c48&"
import script from "./ValuesTable.vue?vue&type=script&lang=js&"
export * from "./ValuesTable.vue?vue&type=script&lang=js&"
import style0 from "./ValuesTable.vue?vue&type=style&index=0&id=45b69c48&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports